<user-management-nav></user-management-nav>
<div class="powerbi-bg">
  <!-- <div class="overlay"></div> -->
  <div class="background-container">
    <div class="glass-container">
      <div class="glass-header d-flex-between mb-4">
        <h2 class="title m-0 sticky-header">Plants</h2>
        <button class="config-button align-center">
          <a href="https://dev.pure.bi/" target="_blank" style="color: aliceblue;">
          CORPORATE &rarr;
        </a>
          <!-- <span class="material-icons" style="vertical-align: middle; font-size: 22px;">settings</span>
          <span class="config-label" style="vertical-align: middle; margin-left: 8px;">Plant Configuration</span> -->
        </button>
      </div>
      <div class="bulk-bar" *ngIf="selectedCount">
        <span>{{ selectedCount }} selected</span>
        <button type="button" class="bulk-unassign-btn" (click)="askUnassign()">
          Unassign selected
        </button>
      </div>

      <div *ngFor="let member of teamMembers; let i = index" class="list-item"
        [class.list-item-selected]="isSelected(member)">
        <div class="item-left">
          <label class="site-select" [title]="'Select ' + member.name">
            <input type="checkbox" [checked]="isSelected(member)" (change)="toggleSelected(member)" />
          </label>
          <div>
            <h3 class="name">{{ member.name }}</h3>
            <p class="description">{{ member.description }}</p>
          </div>
        </div>
        <div class="item-right">
          <button class="view-button" (click)="switchUser(member)">Plant</button>
          <button class="view-button" *ngIf="executiveBySite[member.site_id]"
            (click)="switchExecutive(executiveBySite[member.site_id], executiveBySite[member.site_id], i)">
            Executive
          </button>
        </div>

        <button type="button" class="unassign-btn" [title]="'Unassign ' + member.name"
          (click)="askUnassign(member)">
          <span class="material-icons">close</span>
        </button>
      </div>

    </div>
  </div>


  <div *ngIf="pendingUnassign" class="custom-leave-modal">
    <div class="custom-leave-modal-content unassign-modal-content">
      <h4>Unassign site</h4>
      <p>{{ unassignPrompt }}</p>
      <ul class="unassign-site-list" *ngIf="pendingUnassign.names.length > 1">
        <li *ngFor="let name of pendingUnassign.names">{{ name }}</li>
      </ul>
      <p class="unassign-note">You will lose access to it until an administrator assigns it again.</p>
      <div class="unassign-actions">
        <button class="unassign-yes" [disabled]="unassigning" (click)="confirmUnassign()">
          {{ unassigning ? 'Unassigning...' : 'Yes' }}
        </button>
        <button class="unassign-no" [disabled]="unassigning" (click)="cancelUnassign()">No</button>
      </div>
    </div>
  </div>

  <div *ngIf="showLeavePopup" class="custom-leave-modal">
    <div class="custom-leave-modal-content">
      <p>Browser back-button is disabled on this page.</p>
      <button (click)="onLeave()">Logout</button>
      <button (click)="onStay()">Stay</button>
    </div>
  </div>
  <div *ngIf="popupOpen" class="custom-popup-overlay">
    <div class="custom-popup-container">
      <div class="custom-popup-header">
        <span>Plant Configuration</span>
        <button class="close-btn" (click)="closePopup()">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="custom-popup-content">
        <div *ngIf="!showCheckboxes"></div>
        <button class="add-sites-btn" (click)="onAddSitesClick()">
          + Add Sites for Configuration
        </button>
      </div>
      <div *ngIf="showCheckboxes">
        <form (ngSubmit)="submitSelectedSites()">
          <input type="text" class="site-search-input" placeholder="Search sites..." [(ngModel)]="siteSearch"
            name="siteSearch" (keydown.enter)="$event.preventDefault()" />
          <!-- Show only first 5 filtered sites, and show a message if more exist -->
          <div *ngFor="let site of filteredSites.slice(0, 5)" class="checkbox-item">
            <label>
              <input type="checkbox" [value]="site.site_id" [(ngModel)]="site.selected" name="site_{{site.site_id}}"
                (change)="onSiteCheckboxChange(site)" />
              &nbsp;{{ site.site_name }}
            </label>
          </div>
          <div *ngIf="filteredSites.length > 5" class="remaining-sites-msg">
            +{{ filteredSites.length - 5 }} more sites found
          </div>
          <button type="submit" class="save-sites-btn" *ngIf="!showExecutiveConfig">Next >></button>
        </form>
      </div>
      <div *ngIf="showExecutiveConfig" class="executive-config-section">
        <h3>Do you want to configure executive for following site?</h3>
        <div class="radio-group">
          <label>
            <input type="radio" name="execConfig" value="yes" [(ngModel)]="executiveConfigChoice" /> Yes
          </label>
          <label>
            <input type="radio" name="execConfig" value="no" [(ngModel)]="executiveConfigChoice" /> No
          </label>
        </div>
        <ul class="selected-sites-list">
          <li *ngFor="let site of selectedSitesForConfig; let i = index">
            <ng-container *ngIf="executiveConfigChoice === 'yes'; else justSiteName">
              <label>
                <input
                  type="checkbox"
                  [(ngModel)]="site.execSelected"
                  name="execSelected_{{site.site_id}}"
                />
                {{ site.site_name }}
              </label>
              <div *ngIf="site.execSelected" class="exec-inputs">
                <input
                  type="text"
                  class="exec-input"
                  placeholder="Executive Username"
                  [(ngModel)]="site.executiveUsername"
                  name="execUsername_{{site.site_id}}"
                />
                <input
                  type="password"
                  class="exec-input"
                  placeholder="Executive Password"
                  [(ngModel)]="site.executivePassword"
                  name="execPassword_{{site.site_id}}"
                />
              </div>
            </ng-container>
            <ng-template #justSiteName>
              {{ site.site_name }}
            </ng-template>
          </li>
        </ul>
        <div class="final-save-btn-container">
          <button class="final-save-sites-btn" (click)="saveExecutiveConfig()">Save</button>
        </div>
      </div>
      <div *ngIf="executiveConfigSaved && popupOpen" class="summary-section summary-centered">
        <h3>Configuration Summary</h3>
        <ul>
          <li *ngFor="let site of summaryData">
            <strong>{{ site.site_name }}</strong>
            <span *ngIf="site.executiveUsername">
              - Executive: {{ site.executiveUsername }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Summary Popup -->
  <div *ngIf="showSummaryPopup" class="custom-popup-overlay">
    <div class="custom-popup-container">
      <div class="custom-popup-header">
        <span>
          <span class="material-icons spin" style="vertical-align: middle; font-size: 20px; margin-right: 8px;">
            autorenew
          </span>
          Personalise plant configuration in process...
        </span>
        <button class="close-btn" (click)="showSummaryPopup = false">
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="summary-section summary-centered summary-centered1">
        <h3>Configuration Summary</h3>
        <ul>
          <li *ngFor="let site of summaryData">
            <strong>{{ site.site_name }}</strong>
            <span *ngIf="site.executiveUsername">
              - Executive: {{ site.executiveUsername }}
            </span>
          </li>
        </ul>
      </div>
      <div class="api-processing-section summary-centered">
        <div *ngIf="!apiProcessingDone" class="processing-icon-container">
          <span class="material-icons spin" style="font-size: 48px; color: #1976d2;">cloud_sync</span>
          <div>Setting up sites for you...</div>
        </div>
        <div *ngIf="apiProcessingDone" class="processing-icon-container">
          <span class="material-icons" style="font-size: 48px; color: #43a047;">check_circle</span>
          <div>Sites setup complete!</div>
        </div>
      </div>
      <div class="api-processing-section summary-centered">
        <div *ngIf="!executiveApiProcessingDone" class="processing-icon-container">
          <span class="material-icons spin" style="font-size: 48px; color: #1976d2;">cloud_sync</span>
          <div>Setting up executives for you...</div>
        </div>
        <div *ngIf="executiveApiProcessingDone" class="processing-icon-container">
          <span class="material-icons" style="font-size: 48px; color: #43a047;">check_circle</span>
          <div>Executive setup complete!</div>
        </div>
      </div>
      <div *ngIf="executiveCountdown > 0" style="margin-top: 10px; text-align: center;">
        <span
          [ngStyle]="{
        color: executiveCountdown > 10 ? 'red' : (executiveCountdown > 5 ? 'orange' : 'green'),
        fontWeight: 'bold'
          }"
        >
          {{
        executiveCountdown > 10
          ? 'Finalizing plant setup...'
          : executiveCountdown > 5
            ? 'Almost done, please wait...'
            : 'Wrapping up, just a moment...'
          }}
        </span>
        <br />
        <span>
          {{ executiveCountdown }} seconds...
        </span>
      </div>
    </div>
  </div>
</div>